import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

/**
 * Respuesta del ciclo de vida del token de un módulo embebido (OPB-263).
 *
 * `url` viene ya armada desde el backend, lista para usar como `src` del
 * iframe — no se concatena nada acá (aclarado por el cliente, documento de
 * especificación de Tarifas confirmado 2026-10-05).
 */
export interface IntegrationModuleTokenResponse {
    url: string;
    expiresAt: string;
}

export interface IntegrationModuleRevokeResponse {
    revoked: boolean;
}

/**
 * Cliente del registro parametrizable de integraciones embebidas (OPB-263).
 * Ruta única genérica en el backend — un módulo nuevo no requiere tocar
 * este servicio, solo agregar una entrada de ruta con su `moduleCode`.
 */
@Injectable({
    providedIn: 'root',
})
export class IntegrationModulesService {
    private readonly baseUrl = `${environment.apiUrl}/v1/integraciones`;

    constructor(private readonly http: HttpClient) {}

    getToken(moduleCode: string): Observable<IntegrationModuleTokenResponse> {
        return this.http.get<IntegrationModuleTokenResponse>(
            `${this.baseUrl}/${moduleCode}/token`
        );
    }

    renewToken(moduleCode: string): Observable<IntegrationModuleTokenResponse> {
        return this.http.post<IntegrationModuleTokenResponse>(
            `${this.baseUrl}/${moduleCode}/token/renovar`,
            {}
        );
    }

    revokeToken(moduleCode: string): Observable<IntegrationModuleRevokeResponse> {
        return this.http.post<IntegrationModuleRevokeResponse>(
            `${this.baseUrl}/${moduleCode}/token/revocar`,
            {}
        );
    }
}
